import { Button } from 'blaze-ui/Button'
import Styles from './AutopilotProUpgradeButton.module.scss'
import { useOpenAutopilotUpgrade } from 'hooks/useOpenAutopilotUpgrade'
import cx from 'classnames'
import LockOpen3 from 'blaze-ui/icons/24/LockOpen3'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface AutopilotProUpgradeButtonProps {
  className?: string
  variant?: 'pro' | 'upgrade'
  children?: React.ReactNode
}

export const AutopilotProUpgradeButton = ({ className, variant = 'pro', children }: AutopilotProUpgradeButtonProps) => {
  const openVirtualMarketerPlansModal = useOpenAutopilotUpgrade()
  const isSystemRedesignEnabled = useIsSystemRedesign()

  if (isSystemRedesignEnabled) {
    return (
      <Button
        onPress={() => openVirtualMarketerPlansModal()}
        frontIcon={LockOpen3}
        color="var(--upgrade)"
        variant="secondary"
      >
        Upgrade
      </Button>
    )
  }

  return (
    <Button
      frontIcon={LockOpen3}
      onPress={() => openVirtualMarketerPlansModal()}
      className={cx(Styles.upgradeButton, className, Styles[variant])}
      color="#6A00FF"
    >
      {children ?? 'Upgrade'}
    </Button>
  )
}
